import { configureStore } from '@reduxjs/toolkit'

import vakter from "../reducers/vakter";
import options from "../reducers/options";

const store = configureStore({
    reducer: {vakter: vakter, options: options},
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false}),
}); //initialState

export default store;